import { DiToken, registerDiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// biome-ignore lint/style/useNamingConvention: must be that way
export const WORKER_INSTANCE: DiToken<Worker> = new DiToken<Worker>('workerInstance');

export function registerWorkerInstance(worker: Worker): void {
  registerDiToken(WORKER_INSTANCE, () => worker);
}
